import { Suspense } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'
import { ReactRouter5Adapter } from 'use-query-params/adapters/react-router-5'
import routeconfig, { RouteItem } from '../../config/route'
import Login from '../../containers/Login'
import Logout from '../../containers/Logout'
import AuthenticatedPage from '../AuthenticatedPage'
import Page from '../Page/Page'

const pageRoute = (item: RouteItem): JSX.Element => (
  <Route exact path={item.path} key={item.title}>
    <Suspense fallback={<div>Loading...</div>}>
      <item.container />
    </Suspense>
  </Route>
)

const Router = (): JSX.Element => {
  const publicRoutes = routeconfig.filter((item) => !item.requireAuth)
  const authRoutes = routeconfig.filter((item) => item.requireAuth)

  return (
    <QueryParamProvider adapter={ReactRouter5Adapter}>
      <Switch>
        <Route exact path="/login">
          <Login />
        </Route>
        <Route exact path="/logout">
          <Logout />
        </Route>
        {publicRoutes.map((item) => (
          <Route exact path={item.path} key={item.title}>
            <Page>
              <Suspense fallback={<div>Loading...</div>}>
                <item.container />
              </Suspense>
            </Page>
          </Route>
        ))}
        <Route>
          <AuthenticatedPage>
            <Page>
              <Switch>
                {authRoutes.map(pageRoute)}
                <Route path="*">
                  <Redirect to="/" />
                </Route>
              </Switch>
            </Page>
          </AuthenticatedPage>
        </Route>
      </Switch>
    </QueryParamProvider>
  )
}

export default Router
